@if (client$ | async; as client) {
    <h1 mat-dialog-title>Transfer workspace: {{ client.config.data.name }}</h1>
    <div mat-dialog-content class="flex column">
        <p>Transfer this workspace to another user.</p>
        <form [formGroup]="form">
            <p>New Owner:</p>
            <frog-user-picker [multiple]="false" formControlName="user"></frog-user-picker>
            <p>
                Please type <b>{{ client.config.data.name }}</b> to confirm.
            </p>
            <mat-form-field appearance="fill">
                <input matInput required formControlName="confirm" />
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-stroked-button color="warn" [disabled]="!form.valid" (click)="confirm()">
            I understand, transfer this workspace
        </button>
    </div>
}
